export { TorchesHeroBanner } from './TorchesHeroBanner'
